import styled from 'styled-components'
import tw from 'twin.macro'

export const CookieBannerContainer = styled.div`
  ${tw`sticky left-0 right-0 bottom-0 z-50`}
`
